export default __webpack_public_path__ + "static/media/carousel-1.f7870367.jpg";